<template>
  <div v-on:click="closeTopPickers" id="pictureWall">

    <loader fade-in="fadeIn" fade-out="fadeOut" identifier="mainPictureWall"></loader>

    <div id="zoomElement"
    v-if="pictureWallActive"
    v-bind:style="{ backgroundImage: 'url('+activeBG+')' }"
    v-bind:class="{ outer: true, opacityHide: hideImage }">

      <div
      v-bind:style="{ backgroundImage: 'url('+activeOverlay+')' }"
      v-if="activeOverlay" class="overlayBG"></div>

      <div v-bind:style="{ left: leftWallPosition }" id="draggableContainer" v-if="currentPictureWall" class="articlesContainer">

        <div 
          :key="index"
          v-bind:class="{ blink: highlightPictureWallItems, item: true, active: currentPictureWallField == getArticleFieldID(article.item), hasFrame: chosenFrames[getArticleFieldID(article.item)], hasArticle: chosenArticles[getArticleFieldID(article.item)], landscape: checkLandScape(article) }"
          v-bind:style="{ top: article.top + '%', left: article.left + '%' }"
          v-bind:data-size="article.size"
          v-bind:data-position="index"
          v-bind:data-item-index="index"
          v-for="(article, index) in currentPictureWall.articles">

            <div v-if="!chosenArticles[getArticleFieldID(article.item)]" class="inner">
              {{ article.size }}
            </div> <!-- inner -->

            <div
            v-bind:style="{ background: 'url('+getArticleImage(chosenArticles[index + 1]) +')' }"
            class="chosenArticle" v-else>
            </div>

            <div class="frame" v-if="chosenFrames[getArticleFieldID(article.item)]">
              <img v-bind:src="getFrameImage(article)">
            </div> <!-- frame -->

         </div> <!-- item -->

      </div> <!-- articlesContainer -->

      <!-- Welcome section -->
      <welcome v-if="showWelcome"></welcome>

    </div> <!-- outer -->

    <notification-tooltip  click-hide="true" position="middle" identifier="heartInfo" :show-once="true" title="heartInfoTitle" text="heartInfo" key="buyHere" v-if="currentPicker == 'articles'"></notification-tooltip>
    <notification-tooltip position="buyButton" title="purchaseNowTitle" text="purchaseNow" identifier="buyHere" v-if="steps.complete && currentPicker == ''"></notification-tooltip>

    <input type="hidden" v-bind:value="background">

  </div> <!-- #pictureWall -->
</template>

<script>

import Welcome from 'components/PictureWall/Welcome'
import NotificationTooltip from 'components/Misc/NotificationTooltip'

export default {

  components: {
    Welcome,
    NotificationTooltip
  },

  data: function(){
    return{
      panZoomActive: false,
      hideImage: false,
      activeBG: '/backgrounds/10-blue.jpg',
      activeOverlay: false,
      imageUrl: this.getWGUrl(),
      pictureWallActive: true,
    }
  },

  computed: {

    showWelcome(){

      var show = true;

      $.each(this.steps, function(index, value){
        if(value)
          show = false;
      })

      return show;

    },

    highlightPictureWallItems(){
      return this.$store.state.highlightPictureWallItems
    },

    currentPictureWall(){

      var self = this;

      // Get data
      var currentWall = self.$store.state.pictureWall

      // Return
      return currentWall
    },

    // Background
    background(){

      var self = this;
      var background = self.$store.state.background;
      var color = self.$store.state.pictureWallColor;

      // Handle background image
      if(typeof background.colors != 'undefined' && background)
      {
          // Get urls
          // Check required width
          var requiredWidth = self.pictureWallWidth();
          var image = background.colors[color.key];

          if(!requiredWidth)
            var url = self.imageUrl + "/backgrounds/" + image;

          // If transformed image use cloudinary to get correct size
          else
            var url = window.appSettings.getResizedImageFromCloud(requiredWidth, image, 'backgrounds/');

          if(self.currentPicker == 'backgrounds')
            self.$store.commit('startLoading', 'mainPictureWall');

          // Preload image before changing
          var image = new Image();
          image.onload = function()
          {
            self.activeBG = url;
            self.$store.commit('stopLoading', 'mainPictureWall');
          }
          image.src = url;

          // Handle overlay
          overlay = false;
          if(background.id == 10){

            var fileName =  background.id + "-overlay.png";

            if(!requiredWidth)
              var overlay = self.imageUrl + "/backgrounds/" + fileName;

            // If transformed image use cloudinary to get correct size
            else
              var overlay = window.appSettings.getResizedImageFromCloud(requiredWidth, fileName, 'backgrounds/');
          }

          self.activeOverlay = overlay;

          // Remove loading failsafe
          setTimeout(
          function()
          {
            self.$store.commit('stopLoading', 'mainPictureWall');
          }, 3000);

          return url;
      }

      self.activeBG = self.imageUrl + '/backgrounds/10-blue.jpg';

      if(typeof self.$store.state.pictureWall.articles != 'undefined'){
        self.activeOverlay = self.imageUrl + '/backgrounds/10-overlay.png';
      }

      return false;

    },

    // Decide left position depending on background
    leftWallPosition(){

      var background = this.$store.state.background;
      var left = 0;

      if(background && background.id){

        if(background.id == "6"){

           var screen = $(window).width()

           // Mobile
           if(screen <= 780){
              left =  "-26%";
           }

           // Desktop
           else{
              left = "-16%";
           }

        }

        if(background.id == "7"){
          left = "-9%";
        }

      }

      return left;

    },


    currentPictureWallField(){
      return this.$store.state.currentWallField;
    },

    chosenArticles(){
      return this.$store.state.chosenArticles;
    },

    chosenFrames(){
      return this.$store.state.chosenFrames;
    },

    pictureWallColor(){
      return this.$store.state.pictureWallColor;
    }

  },

  methods: {

    closeTopPickers(){
      window.eventHub.$emit('closeRightMenus', 'all');
    },

    initZoom(){

      var panzoom = require('jquery.panzoom')

      var zoomElement = $("#zoomElement");

      if(this.panZoomActive){
        zoomElement.panzoom("destroy");
      }

      zoomElement.panzoom({
        contain: 'invert',
        cursor: "default",
        maxScale: 1,
        minScale: 1,
      });

      zoomElement.parent().on('mousewheel.focal', function( e ) {
        e.preventDefault();
        var delta = e.delta || e.originalEvent.wheelDelta;
        var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
        zoomElement.panzoom('zoom', zoomOut, {
          increment: 0.1,
          //focal: { clientX: e.clientX, clientY: e.clientY }
        });
      });

      this.panZoomActive = true;
    },

    initDrag: function(){

      var self = this;
      var interact = require('interactjs')

      // Unset any current interacts
      interact('#draggableContainer').unset();
      $("#draggableContainer .item").unbind();

      // Remove any transforms
      $("#draggableContainer").css({transform: "translate(0px, 0px)" });

      // target elements with the "draggable" class
      window.vueRender(function(){
          interact('#draggableContainer')
          .draggable({

            // enable inertial throwing
            inertia: true,

            // keep the element within the area of it's parent
            restrict: {
              restriction: "parent",
              endOnly: true,
              //elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
              elementRect: { top: 0.10, left: 0.10, bottom: 0.90, right: 0.90 }
            },
            // enable autoScroll
            autoScroll: true,

            // call this function on every dragmove event
            onmove: self.dragMoveListener,
            // call this function on every dragend event
            onend: function (event) {

            },

          });

          interact(document).on('down', function (event) {
            var interaction = event.interaction;
            var canGesture = interaction.target && interaction.target.options.gesture.enabled;
            var maxAllowedPointers = canGesture? 2 : 1;

            while (interaction.pointers.length > maxAllowedPointers) {
                interaction.removePointer(interaction.pointers[0]);
            }
          })

           // Bind click
          interact("#draggableContainer .item").on('tap', function (event) {
            var element = $(event.target)
            if(!element.hasClass("item"))
              element = element.closest(".item")
            var index = element.data("item-index")
            self.clickedItem(self.currentPictureWall.articles[index])
            event.preventDefault();
          }, true /* useCapture */);

      })


    },

    dragMoveListener: function (event) {
      var target = event.target,
          // keep the dragged position in the data-x/data-y attributes
          x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
          y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

      // translate the element
      target.style.webkitTransform =
      target.style.transform =
        'translate(' + x + 'px, ' + y + 'px)';

      // update the posiion attributes
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);

    },


    clickedItem(article){

      var format = "portrait";

      if(typeof article.format != 'undefined')
          format = article.format;
     
      var conditions = article.size + format;

      // Update vuex store with current picture wall field and conditions
      this.$store.commit('currentWallField', article.item);
      this.$store.commit('currentWallFieldConditions', conditions);
      this.$store.commit('currentWallFieldSize', article.size);

      // Open picker for pickarticle
      window.eventHub.$emit('clickedPictureWallItem');

    },

    getArticleIndex: function(itemNumber){

      if(itemNumber == 0)
        return itemNumber;

      return itemNumber - 1;
    },

    getArticleFieldID: function(itemNumber){
      return itemNumber;
    },

    checkArticle: function(index){
      if(this.$store.state.chosenArticles[index])
        return true

      return false;
    },

    getFrameImage(article){

      var fieldID = this.getArticleFieldID(article.item);
      var size = article.size;
      var articleNumber = this.chosenFrames[fieldID].articleNumber;

      // Check if landscape
      var landscape = "";
      if(this.checkLandScape(article)){
        landscape = "-landscape"
      }

      return window.appSettings.productImageUrl + "/zoom/" + articleNumber + landscape + ".png";

    },

    checkLandScape: function(item){

      if(typeof item.format != 'undefined' && item.format == 'landscape')
        return true;

      return false;

    }


  },

  mounted: function () {

    var self = this;

    // When a new picture wall has been selected
    window.eventHub.$on('newPictureWall', function (data) {
      self.initDrag();
    });

    // When to open article picker
    window.eventHub.$on('clickPictureWallArticle', function (article) {
      self.clickedItem(article);
    });
  }
}
</script>

<style>

/* Control size */
html{
  font-size: 60%;
}

#pictureWall {
  position: relative;
  width: 100%;
  overflow: hidden;
  font-size: 100%;
  z-index: 1;

  &.2x{
    transform: scale(2, 2)
  }

  /* Mobile */
  @media screen and (max-width: 812px) {
    height: calc(100% - 45px);
  }

  /* Tablets and desktop */
  @media screen and (min-width: 780px) {
    height: calc(100% - 49px - env(safe-area-inset-bottom));
  }

  /* Outer container */
  .outer{
    position: relative;
    width: 100%;
    background: #eeeeee; /* standard bg */
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    cursor: default !important;
    transition: background-image 0.2s ease-in;
    background-position: center;
  }

  .overlayBG{
    position: absolute;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;
    z-index: 1;
    left: 0;
    background-position: center;
    pointer-events: none;
  }

  /* Loader */

  .loadContainer{
    position: absolute;
    width: auto;
    bottom: 13px;
    right: 9px;
    padding: 11px 20px;
    z-index: 1;
    background: rgba(255, 255, 255, 0.53);
    border-radius: 3px;
    color: white;
  }

  .loader{

    .fa{
      font-size: 40px;
    }

  }

}

#pictureWall .articlesContainer{

    /* Mobile */
    /*left: 40px;*/
    /*top: 1px;*/
    /*margin-left: 0px;*/
    /*width: 40%;*/
    /*padding-bottom: 39%;*/
    /*height: 0px;*/

    /*border: 1px solid black;*/

    /* All */
    position: absolute;
    top: 20px;
    height: 0px;
    right: 0;
    left: 0;
    margin-left: auto;
    margin-right: auto;
    /*border: 1px solid #91ff00;*/

    /* Desktop */
    @media screen and (min-width: 1668px){
      width: 78%;
      padding-bottom: 47%;
    }

    @media screen and (min-width: 1336px)  and (max-width: 1667px){
      width: 78%;
      padding-bottom: 47%;
    }

    @media screen and (min-width: 1025px) and (max-width: 1335px){
      width: 78%;
      padding-bottom: 47%;
    }

    /* Tablet */
    @media screen and (max-width: 1024px) and (max-height: 768px) {
     width: 107.1%;
     padding-bottom: 65.2%;
    }

    /* Mobile */
    @media screen and (max-width: 1023px) and (max-height: 767px) {
     width: 78.4%;
     padding-bottom: 47.4%;
    }

}

#pictureWall .item{

  position: absolute;
  text-align: center;
  background: #cecece;
  cursor: pointer !important;
  z-index: 99;
  height: 0;
  border: 1px solid rgba(210, 210, 210, 0.45);
  overflow: hidden;

  /* When selected */
  &.active{
    background: white;
  }

  /* When has poster */
  &.hasArticle{
    background: rgba(241, 241, 241, 0.5);
  }

  /* When there is a frame add effects */
  &.hasFrame{
    border: 0px;
    /*box-shadow: 7px 6px 10px -6px rgba(0,0,0,.79);*/
    box-shadow: 3px 0px 14px -3px rgba(0,0,0,.59);

    /* Mobile */
    @media screen and (max-width: 812px) {
      box-shadow: 3px 0px 8px -3px rgba(0,0,0,.59);
    }

  }

  /* Hover effect */
  &:hover{
    opacity: 0.8;
  };

  /* Inner window that holds text */
  .inner{
    position: absolute;
    top: 50%;
    width: 100%;
    margin-top: -1.8vh;
    font-size: 2.4vh;
  }

  /* 13x18 size */
  &[data-size='13x18']{
    width: 5%;
    padding-bottom: 6.69%;

    .inner{
      margin-top: -1vh;
      font-size: 1.6vh;
    }

  }

  /* 21x30 size */
  &[data-size='21x30']{
    width: 7.677%;
    padding-bottom: 10.499%;
  }

  /* 30x40 size */
  &[data-size='30x40']{
    width: 10.8%;
    padding-bottom: 14.2%;

    &.landscape{
      width: 14.06% !important;
      padding-bottom: 10.562% !important;
    }
  }

  /* 50x70 size */
  &[data-size='40x50']{
    width: 13.939%;
    padding-bottom: 17.393%;
  }

  /* 50x70 size */
  &[data-size='50x50']{
    width: 17.499%;
    padding-bottom: 17.489%;
  }

  /* 50x70 size */
  &[data-size='50x70']{
    width: 17.1%;
    padding-bottom: 23.927%;

    &.landscape{
      width: 23.8% !important;
      padding-bottom: 17.29% !important;
    }
  }

  /* 61x91 size */
  &[data-size='61x91']{
    width: 20.699%;
    padding-bottom: 30.999%;
  }

  /* 70x100 size */
  &[data-size='70x100']{
    width: 23.5%;
    /*padding-bottom: 34.2%; */
    padding-bottom: 33.99%;

  }


  .chosenArticle{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-size: cover !important;
    mix-blend-mode: multiply;
  }

  /* Frame */

  .frame{
    position: absolute;
    width: 100%;

    img{
      pointer-events: none;
    }
  }

  &.blink{
    animation-name: pictureWallItemBlink;
    animation-duration: 1.5s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

}

@keyframes pictureWallItemBlink {
    0% { opacity: 1 }
    50% { opacity: 0.5 }
    100% { opacity: 1 }
}

</style>



// WEBPACK FOOTER //
// PictureWall.vue?07fffad4